// extracted by mini-css-extract-plugin
export default {"container":"bw_g","row":"bw_h"};